export const setNewSort = (dataState, sort) => ({
  ...dataState,
  sort: [sort],
});
